module.exports = __webpack_public_path__ + "img/huilv.fdebfe5a.png";